import React, { useEffect } from 'react';

import { QueryInterop as Query } from '@confluence/apollo-relay-interop/entry-points/QueryInterop';

import { ContentViewedEventQuery } from './ContentViewedEventQuery.graphql';

type ContentViewedEventProps = {
	contentId: string;
};

let lastContentId: string;

export const ContentViewedEvent = ({ contentId }: ContentViewedEventProps) => {
	useEffect(() => {
		lastContentId = contentId;
	}, [contentId]);

	return (
		<Query
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query={ContentViewedEventQuery}
			variables={{ contentId }}
			fetchPolicy="network-only"
			skip={lastContentId === contentId}
		>
			{() => null}
		</Query>
	);
};
